// Ввод только цифр с ограничением длины — числовые поля форм (номер стола, лимиты набора).
export const digitsOnly = (value: string, maxLength: number): string =>
    value.replace(/\D/g, "").slice(0, maxLength);
